import {useCallback, useMemo} from 'react'
import {useDispatch, useSelector} from 'react-redux'
import {setUpdateSettingsPayload, selectUpdateSettingsPayload} from '../slices/customSettingsSlice'
import {checkBlankInputCompletedProject} from '../../AdminPanel/ProjectDetails/Helper/UpdateProject'
import {useAdminPermission} from './adminPermission'
import {useUserFeedback} from './userFeedback'

export const useUpdateCustomSettings = () => {
  const dispatch = useDispatch()
  const updateSettingsPayload = useSelector(selectUpdateSettingsPayload)
  const {setEventDetails} = useUserFeedback()
  const {updateAdminPermissions, errorUpdatedPermission} = useAdminPermission()

  const handleUpdate = useCallback(
    (updateDetails, handleClickOpen, setShowNotification, setNavigateToProjectList) => {
      const {
        selectedJurisdiction,
        selectedHealthCondition,
        selectedSdoh,
        exit,
        selectedTrendAnalysis,
        selectedUserFeedback,
        selectedExportToggle,
        selectedChatbot,
        selectedChatbotExport,
        selectedChatbotCopy,
        selectedPersona,
        updatePayload
      } = updateDetails
      const selectedOptions = {
        selectedJurisdiction,
        selectedHealthCondition,
        selectedSdoh,
        selectedTrendAnalysis,
        selectedUserFeedback,
        selectedExportToggle,
        selectedChatbot,
        selectedChatbotExport,
        selectedChatbotCopy,
        selectedPersona
      }
      if (exit && checkBlankInputCompletedProject(true, 'customSettings', selectedOptions)) {
        dispatch(setUpdateSettingsPayload(updatePayload))
        handleClickOpen()
      } else {
        updateAdminPermissions({variables: updatePayload}).then(() => {
          if (updatePayload.closeExistingEventFlag) {
            setEventDetails((eventDetails) => ({
              ...eventDetails,
              EVENT_ID: null,
              EVENT_NAME: null,
              USER_EMAIL: null,
              HAS_RECORDING: null,
              IS_ACTIVE: null
            }))
          }
          setShowNotification(true)
          if (exit && !errorUpdatedPermission) {
            setNavigateToProjectList(true)
          }
        })
      }
    },
    [dispatch, updateAdminPermissions, errorUpdatedPermission, setEventDetails]
  )

  const values = useMemo(
    () => ({
      handleUpdate,
      updateSettingsPayload
    }),
    [handleUpdate, updateSettingsPayload]
  )

  return values
}
